import { SubscriptSymbol } from './SubscriptSymbol';

// come implemento:
// symbol={symbols.sym_pa}

//soil:
export const sym_hs = <SubscriptSymbol main="H" sub="s" />;
export const sym_cbrb = <SubscriptSymbol main="CBR" sub="b" />;
export const sym_cbrsb = <SubscriptSymbol main="CBR" sub="sb" />;
export const sym_cbrsg = <SubscriptSymbol main="CBR" sub="sg" />;
export const sym_ub = <SubscriptSymbol main="μ" sub="b" />;
export const sym_usb = <SubscriptSymbol main="μ" sub="sb" />;
export const sym_usg = <SubscriptSymbol main="μ" sub="sg" />;
export const sym_dw = <SubscriptSymbol main="D" sub="w" />;

//cargo:
export const sym_pc = <SubscriptSymbol main="P" sub="c" />;
export const sym_pdyn = <SubscriptSymbol main="P" sub="dyn" />;
export const sym_sigma_sb = <SubscriptSymbol main="σ" sub="sb" />;
export const sym_pp = <SubscriptSymbol main="P" sub="p" />;

//stab:
export const sym_hbs = <SubscriptSymbol main="h'" sub="bs" />;
export const sym_hsbs = <SubscriptSymbol main="h'" sub="sbs" />;
export const sym_dvs = <SubscriptSymbol main="d" sub="vs" />;
export const sym_rs = <SubscriptSymbol main="r" sub="s" />;
//unstab:
export const sym_hbu = <SubscriptSymbol main="h'" sub="bu" />;
export const sym_hsbu = <SubscriptSymbol main="h'" sub="sbu" />;
export const sym_dvu = <SubscriptSymbol main="d" sub="vu" />;
export const sym_ru = <SubscriptSymbol main="r" sub="u" />;

// railway geometry:
export const sym_br = <SubscriptSymbol main="b" sub="r" />;
export const sym_ts = <SubscriptSymbol main="t" sub="s" />;
export const sym_bs = <SubscriptSymbol main="b" sub="s" />;
export const sym_as = <SubscriptSymbol main="α" sub="s" />;

// geogrid ballast:
export const sym_hb = <SubscriptSymbol main='h"' sub="b" />;

// paved:
export const sym_sx = <SubscriptSymbol main="S" sub="x" />;
export const sym_so = <SubscriptSymbol main="S" sub="o" />;
export const sym_po = <SubscriptSymbol main="P" sub="o" />;
export const sym_pt = <SubscriptSymbol main="P" sub="t" />;
export const sym_a1 = <SubscriptSymbol main="a1" sub="" />;
export const sym_a2 = <SubscriptSymbol main="a2" sub="" />;
export const sym_a3 = <SubscriptSymbol main="a3" sub="" />;
export const sym_sn_final = <SubscriptSymbol main="SN" sub="final" />;
export const sym_h1 = <SubscriptSymbol main="h" sub="1" />;
export const sym_h2 = <SubscriptSymbol main="h" sub="2" />;
export const sym_h3 = <SubscriptSymbol main="h" sub="3" />;
export const sym_d1 = <SubscriptSymbol main="D" sub="1" />;
export const sym_d2 = <SubscriptSymbol main="D" sub="2" />;
export const sym_d3 = <SubscriptSymbol main="D" sub="3" />;

// geogrid specific
export const sym_rw = <SubscriptSymbol main="r" sub="w" />;
export const sym_pa = <SubscriptSymbol main="P" sub="a" />;
export const sym_pw = <SubscriptSymbol main="p" sub="w" />;
export const sym_ev2 = <SubscriptSymbol main="E" sub="v2" />;

// i seguenti li richiamo cosi: symbols.sym_pgeo(geogridNum)
export const sym_pgeo = (sub: string | number = '') => <SubscriptSymbol main="p" sub={`${sub}`} />;
export const sym_ed = (sub: string | number = '') => <SubscriptSymbol main="ε" sub={`d${sub}`} />;
export const sym_treq = (sub: string | number = '') => <SubscriptSymbol main="T" sub={`req${sub}`} />;
export const sym_tnom = (sub: string | number = '') => <SubscriptSymbol main="T" sub={`nom${sub}`} />;

// Tensile contribution symbols (Tz, Tp, Tm)
export const sym_tz = (sub: string | number = '') => <SubscriptSymbol main="T" sub={`z${sub}`} />;
export const sym_tp = (sub: string | number = '') => <SubscriptSymbol main="T" sub={`p${sub}`} />;
export const sym_tm = (sub: string | number = '') => <SubscriptSymbol main="T" sub={`m${sub}`} />;

// geogrid base coourse : b
export const sym_yb = <SubscriptSymbol main="γ" sub="b" />;
export const sym_phib = <SubscriptSymbol main="φ" sub="b" />;
export const sym_alphab = <SubscriptSymbol main="α" sub="b" />;
export const sym_cb = <SubscriptSymbol main="c" sub="b" />;
// geogrid base coourse : s
export const sym_ys = <SubscriptSymbol main="γ" sub="s" />;
export const sym_phis = <SubscriptSymbol main="φ" sub="s" />;
export const sym_alphas = <SubscriptSymbol main="α" sub="s" />;
export const sym_cs = <SubscriptSymbol main="c" sub="s" />;

// unpaved:
export const sym_P = 'P';
export const sym_W = 'W';
export const sym_p = 'p';
export const sym_Np = <SubscriptSymbol main="N" sub="p" />;
export const sym_s = 's';
export const sym_cbrbc = <SubscriptSymbol main="CBR" sub="bc" />;
export const sym_ev2bc = <SubscriptSymbol main="E" sub="v2bc" />;
export const sym_ev2sg = <SubscriptSymbol main="E" sub="v2sg" />;
export const sym_hu = <SubscriptSymbol main="h" sub="u" />;
export const sym_hgtx = <SubscriptSymbol main="h" sub="gtx" />;
export const sym_hgg = <SubscriptSymbol main="h" sub="gg" />;
export const sym_delta_h_gtx = <SubscriptSymbol main="Δh" sub="gtx" />;
export const sym_delta_h_gg = <SubscriptSymbol main="Δh" sub="gg" />;

// Raggruppamento opzionale (se vuoi importare tutto come oggetto)
export const symbols = {
    sym_hs,
    sym_cbrb,
    sym_cbrsb,
    sym_cbrsg,
    sym_ub,
    sym_usb,
    sym_usg,
    sym_dw,
    sym_pc,
    sym_pdyn,
    sym_sigma_sb,
    sym_hbs,
    sym_hsbs,
    sym_dvs,
    sym_rs,
    sym_hbu,
    sym_hsbu,
    sym_dvu,
    sym_ru,
    sym_hb,
    sym_sx,
    sym_so,
    sym_po,
    sym_pt,
    sym_a1,
    sym_a2,
    sym_a3,
    sym_sn_final,
    sym_h1,
    sym_h2,
    sym_h3,
    sym_pa,
    sym_pw,
    sym_ev2,
    sym_P,
    sym_W,
    sym_p,
    sym_Np,
    sym_s,
    sym_cbrbc,
    sym_ev2bc,
    sym_ev2sg,
    sym_hgtx,
    sym_hgg,
    sym_delta_h_gtx,
    sym_delta_h_gg,
};
